// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".username-form[data-v-55e475ec]{padding:0 12px;margin:auto}.username-form .icon-rename[data-v-55e475ec]{margin-left:8px;padding-left:36px;background-position:12px}.username-form__wrapper[data-v-55e475ec]{display:flex}.username-form__input[data-v-55e475ec]{padding-right:var(--clickable-area);width:230px}.username-form__button[data-v-55e475ec]{margin-left:-44px;background-color:transparent;border:none}\n", ""]);
// Exports
module.exports = exports;
